module.exports = __webpack_public_path__ + "img/KUBO_ROUND.ef3ddcc2.png";